import api from './api';
import i18n from '../i18n/i18n';

/**
 * Payments Service
 * Handles payment-related API calls
 */
const paymentsService = {

  /**
   * Create Stripe Checkout Session
   * Redirects user to Stripe payment page
   *
   * @param {number} productId - ID des Produkts
   * @param {string|null} affiliateCode - Optional: Affiliate-Code
   * @returns {Promise<{checkoutUrl: string, sessionId: string}>}
   */
  createCheckout: (productId, affiliateCode = null, gaClientId = null) =>
    api.post('/payments/create-checkout', {
      productId,
      affiliateCode,
      gaClientId,
      // Sprache der Checkout-Seite (Stripe locale) + Fallback für buyer_locale
      // im Backend, falls der Käufer kein eingeloggtes Profil hat.
      locale: i18n.language === 'en' ? 'en' : 'de'
    }),
  
  /**
   * Verify Checkout Session
   * Called after successful payment redirect
   * 
   * @param {string} sessionId - Stripe Session ID from URL
   * @returns {Promise<{paymentStatus: string, productId: string, amount: number}>}
   */
  verifySession: (sessionId) => 
    api.get(`/payments/verify-session/${sessionId}`),
  
  /**
   * Get user transactions (as seller)
   */
  getTransactions: () => api.get('/payments/transactions'),
  
  /**
   * Get user purchases (as buyer)
   */
  getPurchases: () => api.get('/payments/purchases'),
};

export default paymentsService;
